/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FormControl, InputLabel, Select } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from "@mui/icons-material/Search";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import Checkbox from "@mui/material/Checkbox";

import {
  Alert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Modal,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, Delete } from "@mui/icons-material";
import { spacing, width } from "@mui/system";
import { withStyles } from "@mui/styles";
import Loading from "../components/Loading";
import axios from "../../CustomAxios";
import BillFilter from "./BillFilter";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import moment from "moment";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);
const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function createData(id, name, customer, description, paid, total, data) {
  return {
    id,
    name,
    customer,
    description,
    paid,
    total,
    data,
  };
}

function createCsvData() { }

const headCells = [
  { key: "id", alignment: "left", label: "Bill ID" },
  { key: "name", alignment: "left", label: "Bill Name" },
  { key: "customer", alignment: "left", label: "Customer Company" },
  { key: "description", alignment: "left", label: "Description" },
  { key: "amount", alignment: "center", label: "Bill Amount" },
  { key: "pending", alignment: "center", label: "Pending " },
  { key: "data.billing_date", alignment: "center", label: "Billing Date" },
];

const detailedCsvHeadCells = [
  { key: "bill_id", alignment: "center", label: "Bill ID" },
  { key: "bill_name", alignment: "center", label: "Bill Name" },
  { key: "description", alignment: "center", label: "Description" },
  { key: "customer_company", alignment: "center", label: "Customer Company" },
  { key: "challan_id", alignment: "center", label: "Challan ID" },
  { key: "job_id", alignment: "center", label: "Job ID" },
  { key: "plate_name", alignment: "center", label: "Plate Name" },
  { key: "baking_cost", alignment: "center", label: "Baking Cost" },
  { key: "baking_quantity", alignment: "center", label: "Baking Quantity" },
  { key: "print_cost", alignment: "center", label: "Print Cost" },
  { key: "print_quantity", alignment: "center", label: "Print Quantity" },
  { key: "selling_cost", alignment: "center", label: "Selling Cost" },
  { key: "plate_quantity", alignment: "center", label: "Quantity" },
  { key: "row_cost", alignment: "center", label: "Row Cost" },
  {
    key: "row_cost_with_taxes",
    alignment: "center",
    label: "Row Cost With Taxes",
  },
  { key: "bill_amount", alignment: "center", label: "Bill Amount" },
  { key: "pending", alignment: "center", label: "Pending" },
  { key: "billing_date", alignment: "center", label: "Bill Date" },
];

const EnhancedTableHead = (props) => {
  const {
    download,
    viewPermission,
    editPermission,
    deletePermission,
    numSelected,
    onSelectAllClick,
    rowCount,
  } = props;
  const [head, setHeads] = useState(headCells);
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  useEffect(() => {
    setHeads((prev) => [
      ...prev,
      { id: "payment", alignment: "center", label: "Payment" },
    ]);

    if (download) {
      setHeads((prev) => [
        ...prev,
        { id: "download", alignment: "center", label: "Download" },
      ]);
      if (authData?.type !== "customer_user") {
        setHeads((prev) => [
          ...prev,
          { id: "sendMail", alignment: "center", label: "Mail Invoice" },
        ]);
      }
    }
    if (viewPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "view", alignment: "center", label: "View" },
      ]);
    }
    if (editPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "edit", alignment: "center", label: "Edit" },
      ]);
    }
    if (deletePermission) {
      setHeads((prev) => [
        ...prev,
        { id: "delete", alignment: "center", label: "Delete" },
      ]);
    }
    setHeads((prev) => [
      ...prev,
      { id: "irn_no", alignment: "center", label: "IRN" },
    ]);
  }, [download, viewPermission, editPermission, deletePermission]);

  return (
    <TableHead>
      <TableRow>
        {(download && authData?.type !== 'customer_user') && <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />
        </TableCell>}
        {head.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const getCompanies = async (setCompany) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/customer_company?limit=500`,
      config
    );
    if (data.success) {
      setCompany(data.data.data);
    }
  } catch (e) {
    console.log(e);
  }
};

const getApCompanies = async (setApCompany) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };

    const companydata = await axios.get(
      `/api/v1/${userData.type}/ap_company`,
      config
    );
    if (companydata.data.success) {
      setApCompany(companydata.data.data.data);
    }
  } catch (e) {
    console.log(e);
  }
};

const EnhancedTableToolbar = (props) => {
  const [company, setCompany] = useState([]);
  const [apCompany, setApCompany] = useState([]);
  const {
    numSelected,
    selectedCompany,
    csvChallanData,
    setSelectedCompany,
    job_id,
    challan_id,
    bill_id,
    setFilter,
    setJobSearch,
    setChallanSearch,
    setBillSearch,
    rows,
    setOnSearch,
    irnStatus,
    setIrnStatus,
    createdDateFrom,
    setCreatedDateFrom,
    createdDateTo,
    setCreatedDateTo,
    searchType,
    setSearchType,
    setPaymentCompleted,
    paymentCompleted,
    selectedApCompany,
    setSelectedApCompany,
    csvPermission,
    selectedBillIds,
    handleBulkEmails,
    cashPayment,
    setCashPayment,
    auths,
    setSelectedBillIds
  } = props;
  const navigate = useNavigate();
  useEffect(() => {
    getCompanies(setCompany);
    getApCompanies(setApCompany);
  }, []);
  const userData = JSON.parse(localStorage.getItem("AuthData"));

  let structuredRows = [];
  rows.forEach((row) => {
    let paidAmount = row.paid.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
    });
    let totalAmount = row.total.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
    });
    let billAmount = paidAmount + " / " + totalAmount;
    let pending = (row.total - row.paid).toLocaleString("en-In", {
      maximumFractionDigits: 2,
    });

    let obj = {
      ...row,
      amount: billAmount,
      pending: pending,
    };

    structuredRows.push(obj);
  });

  let timestamp = moment().format("DD-MM-YY HH:mm");
  const csvReport = {
    filename: `Bills_${timestamp}.csv`,
    headers: headCells,
    data: structuredRows,
  };
  const csvChallanReport = {
    filename: `Detailed_Bills_${timestamp}.csv`,
    headers: detailedCsvHeadCells,
    data: csvChallanData,
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setOnSearch(true);
        setSearchType(searchType);
      }}
    >
      <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Bills
          </Typography>
        )}

        <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
          {numSelected > 0 && (userData.type !== "customer_user") && (
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                handleBulkEmails(selectedBillIds)
                setSelectedBillIds([]);
              }
              }
            >
              Send Bulk Emails
            </Button>
          )}
          {csvPermission && userData.type === "super_admin" && (
            <CSVLink
              style={{ color: "green", textDecoration: "none" }}
              {...csvChallanReport}
            >
              <Button
                variant="outlined"
                sx={{ ml: 2, mr: 2 }}
                endIcon={<DownloadIcon />}
              >
                Detailed CSV
              </Button>
            </CSVLink>
          )}
          {csvPermission && (
            <CSVLink
              style={{ color: "green", textDecoration: "none" }}
              {...csvReport}
            >
              <Button
                variant="outlined"
                sx={{ ml: 2, mr: 2 }}
                endIcon={<DownloadIcon />}
              >
                CSV
              </Button>
            </CSVLink>
          )}

          <TextField
            select
            size="small"
            label="Search on"
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            sx={{ width: "108px" }}
          >
            <MenuItem key="bill" value="bill">
              BILL
            </MenuItem>

            <MenuItem key="challan" value="challan">
              CHALLAN
            </MenuItem>
            <MenuItem key="job" value="job">
              JOBS
            </MenuItem>
          </TextField>

          <TextField
            value={
              searchType === "job"
                ? job_id
                : searchType === "challan"
                  ? challan_id
                  : bill_id
            }
            size="small"
            sx={{ margin: "0 8px" }}
            label={
              searchType === "job"
                ? "Search Jobs"
                : searchType === "challan"
                  ? "Search Challans"
                  : "Search Bill"
            }
            placeholder={
              searchType === "job"
                ? "Job ID"
                : searchType === "challan"
                  ? "Challan ID"
                  : "Bill ID"
            }
            onChange={(e) => {
              if (searchType === "job") {
                setJobSearch(e.target.value);
                setChallanSearch("");
                setBillSearch("");
                setSearchType("job");
              } else if (searchType === "challan") {
                setChallanSearch(e.target.value);
                setSearchType("challan");
                setJobSearch("");
                setBillSearch("");
              } else if (searchType === "bill") {
                setBillSearch(e.target.value);
                setSearchType("bill");
                setJobSearch("");
                setChallanSearch("");
              }
            }}
          />

          <Button
            endIcon={<SearchIcon />}
            variant="contained"
            type="submit"
            sx={{ mr: 2 }}
          >
            Search
          </Button>

          <div>
            <BillFilter
              setFilter={setFilter}
              companies={company}
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
              createdDateFrom={createdDateFrom}
              setCreatedDateFrom={setCreatedDateFrom}
              createdDateTo={createdDateTo}
              setCreatedDateTo={setCreatedDateTo}
              setPaymentCompleted={setPaymentCompleted}
              paymentCompleted={paymentCompleted}
              apCompany={apCompany}
              selectedApCompany={selectedApCompany}
              setSelectedApCompany={setSelectedApCompany}
              irnStatus={irnStatus}
              setIrnStatus={setIrnStatus}
              cashPayment={cashPayment}
              setCashPayment={setCashPayment}
              auths={auths}
            />
          </div>
          {userData.type !== "customer_user" && (
            <div>
              <Tooltip title="Create Bill">
                <IconButton size="large">
                  <AddIcon
                    onClick={() => navigate("/dashboard/bill/create-bill")}
                  />
                </IconButton>
              </Tooltip>
            </div>
          )}

        </div>
      </Toolbar>
    </form>
  );
};

function EnhancedTable({
  rows,
  csvChallanData,
  selectedCompany,
  setSelectedCompany,
  setFilter,
  download,
  viewPermission,
  user,
  editPermission,
  challan_id,
  job_id,
  bill_id,
  setJobSearch,
  setChallanSearch,
  setBillSearch,
  up,
  setUp,
  deletePermission,
  setOnSearch,
  searchType,
  setSearchType,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
  setPaymentCompleted,
  paymentCompleted,
  selectedApCompany,
  setSelectedApCompany,
  csvPermission,
  irnStatus,
  setIrnStatus,
  selectedBillIds,
  setSelectedBillIds,
  cashPayment,
  setCashPayment,
  auths
}) {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteReason, setDeleteReason] = useState();
  const [deleteId, setDeleteId] = useState();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const [err, setErr] = useState("");
  const [, setSuccess] = useState(false);
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.split("?")[0]);
  }, []);
  const [message, setMessage] = useState(location?.state?.message);
  const [addPaymentModal, setAddPaymentModel] = useState({
    status: false,
    id: null,
    amountPaid: null,
    totalAmount: null,
    remarks: "",
    cash: false,
  });
  const [addPaymentOptions, setAddPaymentOptions] = useState({
    status: false,
    id: null,
    amountPaid: null,
    totalAmount: null,
    remarks: "",
  });
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleBulkEmails = async (ids) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };

      const results = [];

      for (const id of ids) {
        try {
          const { data } = await axios.get(
            `/api/v1/${authData?.type}/bill/${id}/generate_pdf/send_email`,
            config
          );

          if (data.success) {
            results.push({ id, status: 'success', message: `Email sent for bill ${id}` });
          } else {
            results.push({ id, status: 'error', message: data.message || 'Unknown error' });
          }
        } catch (error) {
          results.push({ id, status: 'error', message: error.message || 'Unknown error' });
        }
      }

      setLoader(false);

      if (results.every(result => result.status === 'success')) {
        setTimeout(() => {
          setMessage("All emails sent successfully");
        }, 2000);
      } else {
        console.log("results", results);
        setTimeout(() => {
          setMessage("Some emails failed to send");
        }, 2000);
      }

      setFilter(true);
      return results;

    } catch (e) {
      setLoader(false);
      console.log(e);
      setMessage("An error occurred while sending emails");
      return false;
    }
  };


  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const currentSelected = new Set(selectedBillIds);
      const currentPageIds = rows.map(row => row.data._id);
      const newSelected = [];
      for (const id of currentPageIds) {
        if (newSelected.length + currentSelected.size >= 10) break;
        if (!currentSelected.has(id)) newSelected.push(id);
      }
      setSelectedBillIds([...currentSelected, ...newSelected]);
    } else {
      const currentPageIds = new Set(rows.map(row => row.data._id));
      const newSelected = selectedBillIds.filter(id => !currentPageIds.has(id));
      setSelectedBillIds(newSelected);
    }
  };

  const handleClickRow = (event, id) => {
    const selectedIndex = selectedBillIds.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      if (selectedBillIds.length >= 10) return;
      newSelected = [...selectedBillIds, id];
    } else {
      newSelected = selectedBillIds.filter(item => item !== id);
    }

    setSelectedBillIds(newSelected);
  };

  const numSelectedOnPage = selectedBillIds.filter(id =>
    rows.some(row => row.data._id === id)
  ).length;

  const isSelected = (id) => selectedBillIds.indexOf(id) !== -1;

  const downloadBill = async (id, customer_company, billCode, billing_date) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const comp = user?.customer_company?._id;
      let url =
        process.env.NODE_ENV === "development"
          ? ""
          : process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      if (authData?.type === "customer_user") {
        url += `/api/v1/${authData?.type}/${comp}/bill/${id}/generate_pdf`;
      } else {
        url += `/api/v1/${authData?.type}/bill/${id}/generate_pdf`;
      }
      fetch(url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      }).then(async (res) => {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display:none";
        const file = await res.blob();
        const url = URL.createObjectURL(file);
        a.href = url;
        const billDate = new Date(billing_date).toISOString().slice(0, 10);
        const billName =
          billCode +
          "-" +
          customer_company.split(" ").join("-") +
          "-" +
          billDate;
        a.download = billName + ".pdf";
        a.click();
        window.URL.revokeObjectURL(url);
        setLoader(false);
      });
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  const sendEmailToCustomer = async (id) => {
    try {
      setLoader(true);

      const authData = JSON.parse(localStorage.getItem("AuthData"));
      let url = `/api/v1/${authData?.type}/bill/${id}/generate_pdf/send_email`;
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.get(url, config);
      if (data.success) {
        setMessage("Mail Sent Successfully");
        setLoader(false);
        setFilter(true);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
      }
    } catch (error) {
      setErr("Some error in sending mail");
      setSuccess(false);
      setLoader(false);
    }
  };

  const payed = async () => {
    let { id: bill_id, amountPaid, totalAmount, remarks, cash } = addPaymentModal;
    if (!bill_id) {
      setErr("Bill Id required");
      snackRef.current.click();
      return;
    }
    if (!addPaymentModal.amountPaid && !addPaymentModal.cash) {
      setErr("Amount required");
      snackRef.current.click();
      return;
    }

    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/bill/${bill_id}/payments`,
        {
          payment_done: true,
          amount: amountPaid,
          total_amount: totalAmount,
          remarks: remarks,
          cash: cash,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        setMessage("Payment details updated successfully");
        setFilter(true); //to update page
        // window.location.reload();
        setUp(up + 3);
        setAddPaymentModel({
          amountPaid: null,
          totalAmount: null,
          id: null,
          status: false,
          cash: false,
        });
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
      snackRef.current.click();
    }
  };

  const deleteBill = async (id, reasonId) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      if (reasonId !== 99) {
        const { data } = await axios.delete(
          `/api/v1/${authData.type}/bill/${id}/${reasonId}`,
          config
        );
        if (data.success) {
          setMessage("Bill Deleted Successfully");
          // setUp(up + 2);
          setFilter(true);
          setLoader(false);
          setSuccess(true);
          // snackRef.current?.click();
        }
      } else if (reasonId === 99) {
        const { data } = await axios.delete(
          `/api/v1/${authData.type}/bill/${id}`,
          config
        );
        if (data.success) {
          setMessage("Bill Deleted Successfully");
          // setUp(up + 2);
          setFilter(true);
          setLoader(false);
          setSuccess(true);
          // snackRef.current?.click();
        }
      }
      setDeleteModal(false);
    } catch (e) {
      setLoader(false);
      console.log(e);
      setErr(e.response.data.error);
      setSuccess(false);
      snackRef.current?.click();
      setDeleteModal(false);
    }
  };

  let paidSum = 0;
  let amountSum = 0;

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : (
          <Alert mt={2} mb={4} severity="success">
            {message}
          </Alert>
        )}
      </Snackbar>
      {!loader ? (
        <Paper>
          <EnhancedTableToolbar
            setOnSearch={setOnSearch}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            setFilter={setFilter}
            job_id={job_id}
            challan_id={challan_id}
            bill_id={bill_id}
            setBillSearch={setBillSearch}
            setJobSearch={setJobSearch}
            setChallanSearch={setChallanSearch}
            numSelected={selectedBillIds.length}
            rows={rows}
            csvChallanData={csvChallanData}
            createdDateFrom={createdDateFrom}
            setCreatedDateFrom={setCreatedDateFrom}
            createdDateTo={createdDateTo}
            setCreatedDateTo={setCreatedDateTo}
            searchType={searchType}
            setSearchType={setSearchType}
            setPaymentCompleted={setPaymentCompleted}
            paymentCompleted={paymentCompleted}
            selectedApCompany={selectedApCompany}
            setSelectedApCompany={setSelectedApCompany}
            csvPermission={csvPermission}
            irnStatus={irnStatus}
            setIrnStatus={setIrnStatus}
            selectedBillIds={selectedBillIds}
            handleBulkEmails={handleBulkEmails}
            cashPayment={cashPayment}
            setCashPayment={setCashPayment}
            auths={auths}
            setSelectedBillIds={setSelectedBillIds}
          />
          <StyledTableContainer>
            <Table size={"small"}>
              <EnhancedTableHead
                setFilter={setFilter}
                numSelected={selectedBillIds.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                download={download}
                viewPermission={viewPermission}
                editPermission={editPermission}
                deletePermission={deletePermission}
                numSelectedOnPage={numSelectedOnPage}
              />
              <TableBody>
                {rows.map((row, index) => {
                  const isItemSelected = isSelected(row?.data?._id);
                  paidSum += row.paid;
                  amountSum += row.total;

                  let paidAmount = row.paid.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                  });
                  let totalAmount = row.total.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                  });
                  let billAmount = paidAmount + " / " + totalAmount;

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClickRow(event, row?.data?._id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row?.data?._id}-${index}`}
                      selected={isItemSelected}
                    >
                      {(download && authData?.type !== 'customer_user') && <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": `enhanced-table-checkbox-${index}`,
                          }}
                        />
                      </TableCell>}
                      <TableCell align="left">{row?.id}</TableCell>
                      <TableCell align="left">{row?.name}</TableCell>
                      <TableCell align="left">{row?.customer}</TableCell>
                      <TableCell align="left">{row?.description}</TableCell>
                      <TableCell align="center">{billAmount}</TableCell>
                      <TableCell align="center">
                        {(row.total - row.paid).toLocaleString("en-In", {
                          maximumFractionDigits: 2,
                        })}
                      </TableCell>
                      <TableCell align="center">
                        {moment(new Date(row?.data?.billing_date)).format(
                          "DD/MM/YYYY"
                        )}
                      </TableCell>
                      {row?.data?.is_payment_completed ? (
                        <TableCell align="center">
                          <CheckIcon style={{ color: "green" }} />
                        </TableCell>
                      ) : authData.type !== "customer_user" ? (
                        <TableCell align="center">
                          <Button
                            onClick={() =>
                              setAddPaymentOptions({
                                status: true,
                                id: row.data._id,
                                amount: 0,
                                totalAmount: row?.total,
                                remarks: "",
                              })
                            }
                          >
                            Add Payment
                          </Button>
                        </TableCell>
                      ) : <TableCell align="center">
                        <ClearIcon style={{ color: "red" }} />
                      </TableCell>}
                      {download ? (
                        <TableCell align="center">
                          <DownloadIcon
                            style={{ cursor: "pointer", color: row?.data?.cash_payment ? "grey" : "black" }}
                            onClick={() => {

                              if (row?.data?.cash_payment) {
                                return;
                              }

                              return downloadBill(
                                row.data._id,
                                row.customer,
                                row.id,
                                row?.data?.billing_date
                              )
                            }
                            }
                          />
                        </TableCell>
                      ) : null}
                      {download && authData.type !== "customer_user" ? (
                        <TableCell align="center">
                          <Tooltip title={`Last Sent: ${row?.data?.last_sent
                            ? moment(row.data.last_sent).utcOffset("+05:30").format("DD-MM-YYYY hh:mm A")
                            : "Send Email"
                            }`}>
                            <AttachEmailIcon
                              style={{ cursor: "pointer", color: row?.data?.cash_payment ? "grey" : "green" }}
                              onClick={() => {
                                if (row?.data?.cash_payment) {
                                  return;
                                }
                                return sendEmailToCustomer(row?.data?._id)
                              }}
                            />
                          </Tooltip>
                        </TableCell>
                      ) : null}
                      {viewPermission ? (
                        <TableCell align="center">
                          <VisibilityIcon
                            style={{ cursor: "pointer", color: "green" }}
                            onClick={() =>
                              navigate(
                                `/dashboard/bill/bill-details/${row.data._id}`,
                                {
                                  state: { bill: row?.data },
                                }
                              )
                            }
                          />
                        </TableCell>
                      ) : null}
                      {editPermission ? (
                        <TableCell align="center">
                          <EditIcon
                            style={{
                              cursor: "pointer",
                              color: row.data?.irn_no ? "#ccc" : "red",
                            }}
                            onClick={() => {
                              if (row?.data?.is_payment_completed) {
                                setErr(
                                  "Cannot Edit Bill after Payment is completed"
                                );
                                setSuccess(false);
                                snackRef.current.click();
                              } else if (row.data?.irn_no) {
                                setErr("Cannot Edit Bill after IRN generation");
                                setSuccess(false);
                                snackRef.current.click();
                              } else {
                                navigate(
                                  `/dashboard/bill/update-bill/${row.data._id}`,
                                  {
                                    state: { bill: row?.data },
                                  }
                                );
                              }
                            }}
                          />
                        </TableCell>
                      ) : null}
                      {deletePermission ? (
                        <TableCell align="center">
                          <Delete
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => {
                              if (row.data?.irn_no) {
                                setDeleteModal(true);
                                setDeleteId(row?.data?._id);
                              } else {
                                deleteBill(row?.data?._id, 99);
                              }
                            }}
                          />
                        </TableCell>
                      ) : null}
                      <TableCell align="center">
                        <Typography
                          style={{ color: row.data?.irn_no ? "green" : "red" }}
                        >
                          {row.data?.irn_no ? "Yes" : "No"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })}
                <TableRow>
                  <TableCell>
                    <b>TOTAL</b>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="center">
                    {paidSum.toLocaleString("en-IN", {
                      maximumFractionDigits: 2,
                    })}{" "}
                    /{" "}
                    {amountSum.toLocaleString("en-IN", {
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                  <TableCell align="center">
                    {(amountSum - paidSum).toLocaleString("en-In", {
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  {download ? <TableCell /> : null}
                  {viewPermission ? <TableCell /> : null}
                  {editPermission ? <TableCell /> : null}
                  {deletePermission ? <TableCell /> : null}
                </TableRow>
              </TableBody>
            </Table>
          </StyledTableContainer>
          <TablePagination
            rowsPerPageOptions={[50, 100, 250]}
            component="div"
            count={total_results}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <Modal
            open={deleteModal}
            onClose={() => {
              setDeleteModal(false);
            }}
          >
            <Card sx={style} style={{ width: "500px" }}>
              <CardContent>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h6">
                      This will also cancel your IRN number
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="label">Select Reason </InputLabel>
                      <Select
                        labelId="label"
                        fullWidth
                        id="label"
                        label="Select Reason"
                        onChange={(e) => setDeleteReason(e.target.value)}
                        value={deleteReason}
                      >
                        {[
                          "Duplicate",
                          "Data entry mistake",
                          "Order Cancelled",
                          "Others",
                        ].map((u, i) => {
                          return (
                            <MenuItem key={i} value={i + 1}>
                              {u}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <Button
                      onClick={() => {
                        if (deleteReason !== undefined) {
                          deleteBill(deleteId, deleteReason);
                          // console.log(deleteId);
                        }
                      }}
                      color="error"
                    >
                      Delete Bill
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Modal>

          <Modal
            open={addPaymentModal.status && addPaymentModal.id}
            onClose={() =>
              setAddPaymentModel({
                status: false,
                id: null,
                amountPaid: null,
                totalAmount: null,
                remarks: "",
              })
            }
          >
            <Card sx={style} style={{ width: "500px" }}>
              <CardContent>
                <Grid item xs={12} md={12} lg={12}>
                  <TextField
                    type="number"
                    fullWidth
                    name="amount"
                    value={addPaymentModal.cash ? addPaymentModal.totalAmount : addPaymentModal.amountPaid}
                    onChange={(e) => {
                      setAddPaymentModel((p) => ({
                        ...p,
                        amountPaid:
                          e.target.value === ""
                            ? e.target.value
                            : Number(e.target.value),
                      }));
                    }}
                    required
                    id="search-field"
                    label="Amount"
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={12} sx={{ mt: 5 }}>
                  <TextField
                    type="text"
                    fullWidth
                    name="remarks"
                    value={addPaymentModal.remarks}
                    onChange={(e) =>
                      setAddPaymentModel((p) => ({
                        ...p,
                        remarks: e.target.value,
                      }))
                    }
                    id="search-field"
                    label="Remarks"
                  />
                </Grid>

                <Box
                  component="span"
                  mt={4}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                >
                  <Button
                    onClick={() => {
                      payed();
                    }}
                    variant="contained"
                    color="success"
                  >
                    {addPaymentModal.cash ? "Confirm Cash Payment" : "SUBMIT"}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Modal>

          <Modal
            open={addPaymentOptions.status && addPaymentOptions.id}
            onClose={() =>
              setAddPaymentOptions({
                status: false,
                id: null,
                amountPaid: null,
                totalAmount: null,
                remarks: "",
              })
            }
          >
            <Card sx={style} style={{ width: "500px" }}>
              <Typography variant="h4" gutterBottom display="inline" sx={{ fontWeight: 600, mb: 2 }}>
                Select Payment Options
              </Typography>
              <CardContent>
                {/* <Grid item xs={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => {
                      setAddPaymentModel({
                        status: addPaymentOptions.status,
                        id: addPaymentOptions.id,
                        amount: addPaymentOptions.totalAmount,
                        totalAmount: addPaymentOptions.totalAmount,
                        remarks: "Cash Payment",
                        cash: true,
                      })
                      setAddPaymentOptions({
                        status: false,
                        id: null,
                        amountPaid: null,
                        totalAmount: null,
                        remarks: "",
                      })
                    }
                    }
                  >
                    Cash Payment
                  </Button>
                </Grid> */}

                <Grid item xs={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 5 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => {
                      setAddPaymentModel({
                        status: addPaymentOptions.status,
                        id: addPaymentOptions.id,
                        amount: addPaymentOptions.amount,
                        totalAmount: addPaymentOptions.totalAmount,
                        remarks: addPaymentOptions.remarks,
                        cash: false,
                      })
                      setAddPaymentOptions({
                        status: false,
                        id: null,
                        amountPaid: null,
                        totalAmount: null,
                        remarks: "",
                      })
                    }
                    }
                  >
                    Bill Payment
                  </Button>
                </Grid>
              </CardContent>
            </Card>
          </Modal>
        </Paper>
      ) : (
        <Loading />
      )}
    </div>
  );
}

function Bills({ auths }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [challanSearch, setCHallanSearch] = useState(
    searchParams.get("challan_id") || ""
  );
  const [jobSearch, setJobSearch] = useState(
    searchParams.get("job_id") || ""
  );
  const [billSearch, setBillSearch] = useState(
    searchParams.get("bill_id") || ""
  );
  const [paymentCompleted, setPaymentCompleted] = useState(
    searchParams.get("payment_completed") || ""
  );
  const [up, setUp] = useState(0);

  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(
    searchParams.get("customer_company_id") || ""
  );
  const [selectedApCompany, setSelectedApCompany] = useState(
    searchParams.get("ap_company") || ""
  );
  const [irnStatus, setIrnStatus] = useState(searchParams.get("has_irn") || "");
  const [download, setDownload] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [user] = useState(auths.user);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);
  const [csvChallanData, setCsvChallanData] = useState([]);
  const [filter, setFilter] = useState(true);
  const [selectedBillIds, setSelectedBillIds] = useState([]);
  const [cashPayment, setCashPayment] = useState(
    searchParams.get("cash_payment") || ""
  );
  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 50
  );
  const [total, setTotal] = useState(0);
  const [onSearch, setOnSearch] = useState(false);
  const [searchType, setSearchType] = useState("bill");

  // ---------- FIX 1: Initialization flag ----------
  const [initialized, setInitialized] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeParams(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    changeParams(0, event.target.value);
  };

  const [createdDateFrom, setCreatedDateFrom] = useState(
    searchParams.get("bill_created_from") || ""
  );
  const [createdDateTo, setCreatedDateTo] = useState(
    searchParams.get("bill_created_to") || ""
  );

  // ---------- FIX 2: Use URLSearchParams for clean navigation ----------
  const changeParams = (queryPage, queryLimit) => {
    const params = new URLSearchParams();
    const id = auths?.user?.customer_company?._id;

    if (selectedCompany) params.set("customer_company_id", selectedCompany);
    if (selectedApCompany) params.set("ap_company", selectedApCompany);
    if (challanSearch) params.set("challan_id", challanSearch);
    if (jobSearch) params.set("job_id", jobSearch);
    if (billSearch) params.set("bill_id", billSearch);
    if (createdDateFrom) params.set("bill_created_from", createdDateFrom);
    if (createdDateTo) params.set("bill_created_to", createdDateTo);
    if (paymentCompleted) params.set("payment_completed", paymentCompleted);
    if (irnStatus) params.set("has_irn", irnStatus);
    if (cashPayment) params.set("cash_payment", cashPayment);
    params.set("page", String(queryPage));
    params.set("limit", String(queryLimit));

    navigate(`/dashboard/bill?${params.toString()}`, { replace: true });

    getBills(
      selectedCompany,
      selectedApCompany,
      id,
      challanSearch,
      jobSearch,
      billSearch,
      paymentCompleted,
      queryPage,
      queryLimit
    );
  };

  // ---------- FIX 3: Fetch on mount using URL params ----------
  const getBills = async (
    selectedCompany,
    selectedApCompany,
    id,
    challan_id,
    job_id,
    bill_id,
    payComp,
    pageProp,
    limitProp
  ) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      let allBills = [];
      let url = "";

      let queryPage = searchParams.get("page");
      let queryLimit = searchParams.get("limit");

      if (pageProp !== undefined) {
        queryPage = pageProp;
      }
      if (limitProp) {
        queryLimit = limitProp;
      }

      if (userData.type === "customer_user") {
        url = `/api/v1/${userData.type}/${id}/bill?challan_id=${challan_id}&is_payment_completed=${payComp}&job_id=${job_id}&bill_id=${bill_id}&page=${queryPage + 1}&limit=${queryLimit}&bill_created_from=${createdDateFrom}&bill_created_to=${createdDateTo}&has_irn=${irnStatus}&cash_payment=${cashPayment}`;
      } else {
        url = `/api/v1/${userData.type}/bill?ap_company=${selectedApCompany}&customer_company_id=${selectedCompany}&challan_id=${challan_id}&job_id=${job_id}&bill_id=${bill_id}&page=${queryPage + 1}&limit=${queryLimit}&is_payment_completed=${payComp}&bill_created_from=${createdDateFrom}&bill_created_to=${createdDateTo}&has_irn=${irnStatus}&cash_payment=${cashPayment}`;
      }

      const { data } = await axios.get(url, config);
      if (data.success) {
        let billIds = [];
        let filteredData = (userData.type === "super_admin" || auths?.user?.role?.permissions.includes("view_cash_bill")) ? data.data.data : data.data.data.filter((bill) => bill?.cash_payment === false || bill?.cash_payment === undefined);

        filteredData.map((element, index) => {
          billIds.push(element._id);
        });

        // ---------- REVISED: Detailed CSV generation with chunking ----------
        if (userData.type === "super_admin") {
          // Chunk billIds into batches of 50
          const chunkSize = 50;
          const chunks = [];
          for (let i = 0; i < billIds.length; i += chunkSize) {
            chunks.push(billIds.slice(i, i + chunkSize));
          }

          let allCsvData = [];
          for (const chunk of chunks) {
            try {
              const csvResponse = await axios.post(
                `/api/v1/${authData?.type}/bill/getCsvData`, // fixed leading slash
                { billIds: chunk },
                config
              );
              if (csvResponse.data.success) {
                allCsvData = allCsvData.concat(csvResponse.data.data);
              } else {
                console.error('Error fetching CSV data for chunk:', chunk, csvResponse.data);
              }
            } catch (error) {
              console.error('Failed to fetch CSV chunk:', error);
              // Continue with other chunks or handle gracefully
            }
          }

          // Warn if data might be incomplete
          if (allCsvData.length < billIds.length) {
            console.warn(`Detailed CSV missing data: expected ${billIds.length} bills, got ${allCsvData.length}`);
          }

          let challanData = [];

          allCsvData.forEach((element) => {
            element.challans?.forEach((challan) => {
              const job = challan.jobs || {};
              const platesInfo = job.platesInfo || {};

              // Bill-level flag: if true, include not_to_bill plates; if false, exclude them.
              const showNotToBill = element.bill.show_not_to_bill !== false;

              // Job.plates is an array in the schema, but handle single-object shape too
              const rawPlates = job.plates;
              const plates = (Array.isArray(rawPlates) ? rawPlates : [rawPlates])
                .filter(Boolean)
                .filter((plate) => {
                  if (plate.production_rejection) return false;               // always skip rejected
                  if (!showNotToBill && plate.not_to_bill) return false;      // skip not_to_bill if bill says so
                  return true;
                });

              plates.forEach((plate) => {
                // If this plate is marked not_to_bill, its cost must be reported as zero
                // (it is only included because bill.show_not_to_bill is true)
                const isNotToBill = plate.not_to_bill === true;

                const bakingCost = isNotToBill ? 0 : Number(plate.baking_cost) || 0;
                const printCost = isNotToBill ? 0 : Number(plate.print_cost) || 0;
                const sellingCost = isNotToBill ? 0 : Number(plate.selling_cost) || 0;

                const bakeQty = Number(plate.bake) || 0;
                const printQty = Number(plate.printout) || 0;
                const plateQty = Number(plate.quantity) || 0;

                const rowCost = isNotToBill
                  ? 0
                  : bakingCost * bakeQty +
                  printCost * printQty +
                  sellingCost * plateQty;

                challanData.push({
                  bill_id: element.bill.bill_id,
                  bill_name: element.bill.name,
                  description: element.bill.description,
                  customer_company: element.bill.customer_company?.[0]?.name || 'N/A',
                  bill_amount: Number(element.bill.total_bill_cost_details.subtotal).toFixed(2),
                  pending: (
                    element.bill.total_bill_cost_details.subtotal -
                    element.bill.total_bill_cost_details.paid
                  ).toFixed(2),
                  billing_date: element.bill.billing_date.slice(0, 10),
                  challan_id: challan.challan_id,
                  job_id: job.job_id,
                  plate_name: `${platesInfo.height || ''}x${platesInfo.width || ''}x${platesInfo.thickness || ''}`,
                  baking_cost: bakingCost.toFixed(2),
                  baking_quantity: plate.bake,
                  print_cost: printCost.toFixed(2),
                  print_quantity: plate.printout,
                  selling_cost: sellingCost.toFixed(2),
                  plate_quantity: plate.quantity,
                  row_cost: rowCost.toFixed(2),
                  row_cost_with_taxes: (rowCost * 0.18 + rowCost).toFixed(2),
                });
              });
            });
          });

          setCsvChallanData(challanData);
        }

        setTotal((userData.type === "super_admin" || auths?.user?.role?.permissions.includes("view_cash_bill")) ? data.data.metadata.total_results : filteredData.length);
        filteredData.map((bill) => {
          allBills.push(
            createData(
              bill.bill_id,
              bill.name,
              bill.customer_company.name,
              bill.description,
              bill.total_bill_cost_details.paid,
              bill.total_bill_cost_details.subtotal,
              bill
            )
          );
        });
      }
      setRows(allBills);
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  // ---------- FIX 4: Clear filters on return from details ----------
  useEffect(() => {
    const returnFlag = sessionStorage.getItem('returnFromBillDetails');
    if (returnFlag === 'true') {
      sessionStorage.removeItem('returnFromBillDetails');
      setSelectedCompany('');
      setSelectedApCompany('');
      setCHallanSearch('');
      setJobSearch('');
      setBillSearch('');
      setCreatedDateFrom('');
      setCreatedDateTo('');
      setPaymentCompleted('');
      setIrnStatus('');
      setCashPayment('');
      navigate('/dashboard/bill', { replace: true });
    }
  }, []);

  // ---------- FIX 5: Main effect – initial mount fetch + filter/onSearch triggers ----------
  useEffect(() => {
    const id = auths?.user?.customer_company?._id;

    if (!initialized) {
      const params = new URLSearchParams(location.search);
      getBills(
        params.get("customer_company_id") || "",
        params.get("ap_company") || "",
        id,
        params.get("challan_id") || "",
        params.get("job_id") || "",
        params.get("bill_id") || "",
        params.get("payment_completed") || "",
        page,
        rowsPerPage
      );
      setInitialized(true);
      return;
    }

    if (filter || onSearch) {
      const resetPage = 0;
      setPage(resetPage);

      const params = new URLSearchParams();
      if (irnStatus) params.set("has_irn", irnStatus);
      if (selectedApCompany) params.set("ap_company", selectedApCompany);
      if (selectedCompany) params.set("customer_company_id", selectedCompany);
      if (challanSearch) params.set("challan_id", challanSearch);
      if (jobSearch) params.set("job_id", jobSearch);
      if (billSearch) params.set("bill_id", billSearch);
      if (createdDateFrom) params.set("bill_created_from", createdDateFrom);
      if (createdDateTo) params.set("bill_created_to", createdDateTo);
      if (paymentCompleted) params.set("payment_completed", paymentCompleted);
      if (cashPayment) params.set("cash_payment", cashPayment);
      params.set("page", String(resetPage));
      params.set("limit", String(rowsPerPage));

      navigate(`/dashboard/bill?${params.toString()}`, { replace: true });

      getBills(
        selectedCompany,
        selectedApCompany,
        id,
        challanSearch,
        jobSearch,
        billSearch,
        paymentCompleted,
        resetPage,
        rowsPerPage
      );

      setFilter(false);
      setOnSearch(false);
    }
  }, [filter, onSearch, initialized]);

  // Permission setup
  useEffect(() => {
    if (
      auths?.user?.role?.permissions.includes("download_bill_pdf") ||
      authData?.type === "super_admin"
    ) {
      setDownload(true);
    }
    if (
      auths?.user?.role?.permissions.includes("view_bill_details") ||
      authData?.type === "super_admin"
    ) {
      setViewPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("update_bill_details") ||
      authData?.type === "super_admin"
    ) {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("delete_bill") ||
      authData?.type === "super_admin"
    ) {
      setDeletePermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("download_csv") ||
      authData?.type === "super_admin"
    ) {
      setCsvPermission(true);
    }
  }, [auths.user]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              BILLS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Typography> Bills</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              setOnSearch={setOnSearch}
              up={up}
              setFilter={setFilter}
              setUp={setUp}
              user={user}
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
              rows={rows}
              csvChallanData={csvChallanData}
              download={download}
              viewPermission={viewPermission}
              editPermission={editPermission}
              challan_id={challanSearch}
              job_id={jobSearch}
              bill_id={billSearch}
              setJobSearch={setJobSearch}
              setChallanSearch={setCHallanSearch}
              setBillSearch={setBillSearch}
              setPaymentCompleted={setPaymentCompleted}
              paymentCompleted={paymentCompleted}
              deletePermission={deletePermission}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
              createdDateFrom={createdDateFrom}
              setCreatedDateFrom={setCreatedDateFrom}
              createdDateTo={createdDateTo}
              setCreatedDateTo={setCreatedDateTo}
              searchType={searchType}
              setSearchType={setSearchType}
              setSelectedApCompany={setSelectedApCompany}
              selectedApCompany={selectedApCompany}
              csvPermission={csvPermission}
              irnStatus={irnStatus}
              setIrnStatus={setIrnStatus}
              selectedBillIds={selectedBillIds}
              setSelectedBillIds={setSelectedBillIds}
              cashPayment={cashPayment}
              setCashPayment={setCashPayment}
              auths={auths}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(Bills);